export default {
    addItem(){
      this.items.push("")
    },
    removeItem(){
      this.items.pop();
    }
  }


// WEBPACK FOOTER //
// ./src/components/flexbox/methods.js